<template>
  <div>
    <PageHeader title="การยืนยันตัวตนสมาชิก"></PageHeader>
    <b-container class="mt-5 px-5" fluid>
      <div class="card card-csq no-shadow">
        <div class="card-body verification-container">
          <b-row>
            <b-col cols="4">
              <label><strong>รหัสนักเรียน</strong></label>
              <b-form-input
                v-model="studentId"
                type="search"
                class="form-control border-1 bg-light"
                autofocus
                placeholder="ค้นหารหัสนักเรียน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>ชื่อผู้เรียน</strong></label>
              <b-form-input
                v-model="studentName"
                type="search"
                class="form-control border-1 bg-light"
                autofocus
                placeholder="ค้นหาชื่อผู้เรียน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>สถานะยืนยันตัวตน</strong></label>
              <b-form-select
                v-model="selectedStatus"
                :options="verificationStatus"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <label><strong>วันที่ขอยืนยันตัวตน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formattedDateOfRequest"
                    placeholder="เลือกวันที่ขอยืนยันตัวตน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="showCalendarRange('date-of-request')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="dateOfRequest"
                  id="date-of-request"
                  style="
                          display: none;
                          float: right;
                          position: relative;
                          will-change: transform;
                          left: 0px;
                          "
                  is-range
                />
              </div>
            </b-col>
            <b-col cols="4">
              <label><strong>วันที่ดำเนินการ</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formattedDateOfProcessing"
                    placeholder="เลือกวันที่ขอยืนยันตัวตน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="showCalendarRange('date-of-processing')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="dateOfProcessing"
                  id="date-of-processing"
                  style="
                          display: none;
                          float: right;
                          position: relative;
                          will-change: transform;
                          left: 0px;
                          "
                  is-range
                />
              </div>
            </b-col>
          </b-row>
          <b-button
            @click="searchMemberIdentityVerification()"
            class="search-btn"
            block
            variant="primary"
          >
            ค้นหา
          </b-button>
        </div>
        <hr />
        <div class="card-body">
          <b-table
            id="member-list"
            :fields="fields"
            :items="memberApprovalList"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isLoading"
            hover
            striped
            show-empty
          >
            <template slot="table-busy" class="text-center text-danger my-2">
              <Loading />
            </template>
            <template #empty>
              <p class="text-center">ไม่มีข้อมูล</p>
            </template>
            <template v-slot:cell(fullName)="data">
              <div v-if="data.item.mp_studentId">
                {{ data.item.mp_studentId }} <br />
              </div>
              {{ fullName(data.item.mp_firstName, data.item.mp_lastName) }}
            </template>
            <template v-slot:cell(dateOfBirth)="data">
              {{ data.item.mp_dob | thaiDateFilter }}
            </template>
            <template v-slot:cell(age)="data">
              {{ age(data.item.mp_dob) }}
            </template>
            <template v-slot:cell(dateOfRequest)="data">
              {{ data.item.mp_requestApproveAt | thaiDateTimeFilter }}
            </template>
            <template v-slot:cell(checkedBy)="data">
              {{ fullName(data.item.adminFirstName, data.item.adminLastName) }}
              <br />
              {{ data.item.mp_adminApproveAt | thaiDateTimeFilter }}
            </template>
            <template v-slot:cell(status)="data">
              <b-badge
                :variant="getStatusVariant(data.item.mp_adminApproveStatus)"
              >
                {{ getTextStatus(data.item.mp_adminApproveStatus) }}
              </b-badge>
            </template>
            <template v-slot:cell(action)="row">
              <div class="table-action">
                <b-button
                  @click="showModalLogs(row.index, row.item.m_id)"
                  variant="outline-secondary"
                  size="sm"
                >
                  <b-icon icon="clock-history"></b-icon>
                </b-button>
                <router-link
                  :to="{
                    name: 'member.identity-verification-info',
                    params: { memberId: row.item.m_id },
                  }"
                >
                  <b-button
                    class="view-detail-btn"
                    variant="outline-primary"
                    size="sm"
                  >
                    ดูข้อมูล
                  </b-button>
                </router-link>
              </div>
              <b-modal
                :ref="'modal-verification-logs-' + row.index"
                :title="
                  'ประวัติการยืนยันตัวตนสมาชิกของ ' +
                    fullName(row.item.mp_firstName, row.item.mp_lastName)
                "
                size="xl"
                centered
                hide-footer
              >
                <b-table
                  id="member-verification-logs"
                  :fields="verificationLogFields"
                  :items="membersApprovalLogs"
                  responsive
                  style="font-size: 14px; border:hidden;"
                  :busy="isLogsLoading"
                  hover
                  striped
                  show-empty
                >
                  <template #table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="field.style"
                    />
                  </template>
                  <template
                    slot="table-busy"
                    class="text-center text-danger my-2"
                  >
                    <Loading />
                  </template>
                  <template #empty>
                    <p class="text-center">ไม่มีข้อมูล</p>
                  </template>
                  <template v-slot:cell(requestAt)="data">
                    {{ data.item.mal_requestApproveAt | thaiDateTimeFilter }}
                  </template>
                  <template v-slot:cell(status)="data">
                    <b-badge
                      :variant="
                        getStatusVariant(data.item.mal_adminApproveStatus)
                      "
                    >
                      {{ getTextStatus(data.item.mal_adminApproveStatus) }}
                    </b-badge>
                  </template>
                  <template v-slot:cell(checkedBy)="data">
                    {{
                      fullName(data.item.mp_firstName, data.item.mp_lastName)
                    }}
                  </template>
                  <template v-slot:cell(approveAt)="data">
                    {{ data.item.mal_adminApproveAt | thaiDateTimeFilter }}
                  </template>
                </b-table>
              </b-modal>
            </template>
          </b-table>
          <b-row class="mt-3" v-if="memberApprovalList.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ memberApprovalList.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="memberApprovalList.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="memberApprovalList.length"
                  aria-controls="member-list"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import Loading from "@/components/shared/Loading";
import { mapActions, mapGetters } from "vuex";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";

export default {
  mixins: [dateMixin],
  components: {
    PageHeader,
    // vSelect,
    DatePicker,
    Loading,
  },
  computed: {
    ...mapGetters("MemberManagement", [
      "memberApprovalList",
      "membersApprovalLogs",
    ]),
    formattedDateOfRequest() {
      return this.getFormattedRange(
        this.dateOfRequest.start,
        this.dateOfRequest.end,
        "date-of-request",
      );
    },
    formattedDateOfProcessing() {
      return this.getFormattedRange(
        this.dateOfProcessing.start,
        this.dateOfProcessing.end,
        "date-of-processing",
      );
    },
  },
  data() {
    return {
      studentId: null,
      studentName: null,
      verificationStatus: [
        { value: "", text: "สถานะทั้งหมด" },
        { value: "APPROVED", text: "ยืนยัน" },
        { value: "SUBMITTED", text: "ยังไม่ยืนยัน" },
        { value: "REJECTED", text: "ปฏิเสธ" },
      ],
      selectedStatus: "",
      dateOfRequest: {
        start: "",
        end: "",
      },
      dateOfProcessing: {
        start: "",
        end: "",
      },
      perPage: 10,
      currentPage: 1,
      isLoading: false,
      isLogsLoading: false,
      fields: [
        {
          label: "ชื่อผู้เรียน",
          key: "fullName",
        },
        {
          label: "E-mail",
          key: "m_email",
        },
        {
          label: "วันเกิด",
          key: "dateOfBirth",
        },
        {
          label: "อายุ",
          key: "age",
        },
        {
          label: "บัตรประชาชน",
          key: "mp_idCard",
        },
        {
          label: "วันที่ขอยืนยันตัวตน",
          key: "dateOfRequest",
        },
        {
          label: "สถานะยืนยันตัวตน",
          key: "status",
        },
        {
          label: "ตรวจโดย",
          key: "checkedBy",
        },
        {
          label: "",
          key: "action",
        },
      ],
      verificationLogFields: [
        {
          label: "วันที่ขอยืนยันตัวตน",
          key: "requestAt",
          style: { minWidth: "200px" },
        },
        {
          label: "สถานะยืนยันตัวตน",
          key: "status",
          style: { minWidth: "150px" },
        },
        {
          label: "ตรวจโดย",
          key: "checkedBy",
        },
        {
          label: "วันที่ตรวจ",
          key: "approveAt",
          style: { minWidth: "200px" },
        },
        {
          label: "เหตุผลการปฏิเสธ",
          key: "mal_adminApproveRemark",
        },
      ],
    };
  },
  mounted() {
    this.fetch(null);
  },
  methods: {
    ...mapActions("MemberManagement", [
      "fetchMemberApprovalList",
      "fetchMemberApprovalLogs",
    ]),
    async fetch(params) {
      this.isLoading = true;
      await this.fetchMemberApprovalList({ params });
      this.isLoading = false;
    },
    searchMemberIdentityVerification() {
      let params = {
        studentId: this.studentId,
        name: this.studentName,
        approveStatus: this.selectedStatus,
        approveStartDate: this.formatDate(this.dateOfProcessing.start),
        approveEndDate: this.formatDate(this.dateOfProcessing.end),
        requestStartDate: this.formatDate(this.dateOfRequest.start),
        requestEndDate: this.formatDate(this.dateOfRequest.end),
      };

      this.fetch(params);
    },
    async showModalLogs(index, mId) {
      this.$refs[`modal-verification-logs-${index}`].show();
      this.isLogsLoading = true;
      await this.fetchMemberApprovalLogs(mId);
      this.isLogsLoading = false;
    },
    age(dateOfBirth) {
      if (!dateOfBirth) return null;

      const birthDate = new Date(dateOfBirth);
      const today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    getStatusVariant(status) {
      const variants = {
        SUBMITTED: "secondary",
        APPROVED: "success",
        REJECTED: "danger",
      };
      return variants[status] || "secondary";
    },
    getTextStatus(status) {
      const text = {
        SUBMITTED: "ยังไม่ยืนยัน",
        APPROVED: "ยืนยัน",
        REJECTED: "ปฏิเสธ",
      };
      return text[status] || "-";
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    fullName(firstName, lastName) {
      if (!firstName || !lastName) {
        return "-";
      }
      return firstName + " " + lastName;
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
.date-range-field .form-control,
.vs__dropdown-toggle,
.custom-select {
  height: 32px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.custom-select {
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>

<style scoped>
.verification-container {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .date-range-field {
    width: 100%;
  }

  .search-btn {
    width: fit-content;
  }
}

.table-action {
  display: flex;
  align-items: center;
  gap: 5px;

  .view-detail-btn {
    width: max-content;
  }
}

.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>
